import { useNavigate } from "react-router-dom";
import ImageLinks from "../../../assets/Images/ImagesLink";
import { useTranslation } from "react-i18next";

function AccountNavBar() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="mt-8 p-4 text-xs font-semibold font-custom relative bg-white rounded-[20px] shadow-[0px_0px_4px_0px_rgba(166,166,166,0.25)] flex">
      <div className="flex gap-10 items-center mx-auto">
        {/* <div
          className="flex flex-col"
          role="button"
          tabIndex={0}
          onClick={() => navigate("/support")}
        >
          <img
            loading="lazy"
            src={ImageLinks.message}
            alt=""
            className="object-contain self-center w-5 aspect-square"
          />
          <p>Support</p>
        </div> */}
        <div
          className="flex flex-col"
          role="button"
          tabIndex={0}
          onClick={() => navigate("/wallet-list")}
        >
          <img
            loading="lazy"
            src={ImageLinks.bx_wallet}
            alt=""
            className="object-contain self-center w-5 aspect-square"
          />
          <p>{t("wallet")}</p>
        </div>
        <div
          className="flex flex-col"
          role="button"
          tabIndex={0}
          onClick={() => navigate("/saved-address")}
        >
          <img
            loading="lazy"
            src={ImageLinks.address_book}
            alt=""
            className="object-contain self-center w-5 aspect-square"
          />
          <p>{t("addresses")}</p>
        </div>
      </div>
      {/* <div className="flex shrink-0 mt-1 bg-white border border-solid border-violet-600 border-opacity-20 h-[7px] rounded-[30px]" /> */}
    </div>
  );
}

export default AccountNavBar;
